import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanel, BasePanelStyle} from "../BasePanel";
import {SubscribeFlowController} from "../../../flows/SubscribeFlowController";
import {styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";


class SubscribePanelStyle extends BasePanelStyle {
    @styleRuleInherit
    paywallPage = {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    };

    @styleRuleInherit
    button = {
        marginBottom: 0,
    };
}

@registerStyle(SubscribePanelStyle)
export class SubscribePanel extends BasePanel {
    getControllerClass() {
        return SubscribeFlowController;
    }
}
